export default "__VITE_ASSET__FYBFF0eW__"